export const showBetterPrice = (price) => {
  const number = price?.toString()?.split(".");
  if (number) {
    if (number[0]?.length >= 4) {
      return number[0] + "." + number[1]?.slice(0, 3);
    }
    if (number[0]?.length >= 2) {
      return number[0] + "." + number[1]?.slice(0, 5);
    }
    if (number[0]?.length === 1 && number[0] >= 1) {
      return number[0] + "." + number[1]?.slice(0, 5);
    }
    if (number[1]?.slice(0, 2) > 1) {
      return number[0] + "." + number[1]?.slice(0, 7);
    }
    if (number[1]?.slice(0, 4) > 1) {
      return number[0] + "." + number[1]?.slice(0, 9);
    }
  }
  return price;
};

export const showBetterCoinBalance = (price) => {
  const cPrice = price?.toString()?.split(".");
  if (cPrice && cPrice[1] == 0) {
    return cPrice[0];
  }
  return price;
};

export const showBetterUsdtBalance = (price) => {
  const cPrice = price?.toString()?.split(".");
  if (cPrice[1])
    if (cPrice[1]?.length > 9) {
      return cPrice[0] + "." + cPrice[1].slice(0, 8);
    }
  return price;
};
